/** 监测链接 */
export {
  track_url_setting,
};

const track_url_setting = {
  value: {},
  children: {
    track_url_type: {
      label: '检测链接类型',
      type: 'radio-group',
      isButton: true,
      options: [
        {
          label: '自定义链接',
          value: 'CUSTOM',
        },
      ],
      value: 'CUSTOM',
      hidden: false,
    },
    track_url: {
      label: '展示检测链接',
      type: 'input',
      hidden: false,
      value: '',
    },
    video_play_effective_track_url: {
      label: '视频有效播放',
      type: 'input',
      hidden: false,
      value: '',
    },
    video_play_done_track_url: {
      label: '视频播放完',
      type: 'input',
      hidden: false,
      value: '',
    },
    video_play_first_track_url: {
      label: '视频开始播放',
      type: 'input',
      hidden: false,
      value: '',
    },
    action_track_url: {
      label: '点击检测链接',
      type: 'input',
      hidden: false,
      rules: [{ required: true, message: '请输入点击检测链接', trigger: 'change' }],
      value: '',
    },
    send_type: {
      label: '数据发送方式',
      type: 'radio-group',
      isButton: true,
      options: [
        {
          label: '服务器端上传',
          value: 'SERVER_SEND',
        },
      ],
      props: {
        multiple: true,
        multipleLimit: 1,
      },
      value: 'SERVER_SEND',
    },
  },
};
